import { useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { IFolderModel, IFolderSortSettings } from 'models/folder.model'
import sortConfigurationFolder from 'api/administration/folders/SortConfiguration'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from 'store/actions/folders.action'

interface UseFolderSortProps {
  item: IFolderModel
}

export const useFolderSort = ({ item }: UseFolderSortProps) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  const save = useCallback(
    async (orderSortSettings: IFolderSortSettings, orderCourses?: string[]) => {
      if (item.id) {
        try {
          setLoading(true)
          const data = await sortConfigurationFolder(
            item.id,
            orderSortSettings,
            orderCourses
          )
          dispatch(fromActions.Actions.updateFolderSuccess(data))
          SuccessToast(t('administration.toastMessages.editSuccess'))
        } catch {
          ErrorToast(t('administration.toastMessages.editError'))
        }
        setLoading(false)
      }
    },
    [dispatch, item.id, t]
  )
  return {
    save,
    loading,
  }
}
